/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StateApi } from '../api/state.api';
import { switchMap, map } from 'rxjs/operators';
import { StateData, StateMst } from '../../../interfaces/masters/state';

@Injectable()
export class StateMstService extends StateData {

  constructor(private api: StateApi) {
    super();
  }


  list(): Observable<StateMst[]> {
    return this.api.list();
  }

  getById(url:string): Observable<StateMst>{
      return this.api.getById(url);
  }

  create(url: string, data:StateMst): Observable<StateMst> {
    return this.api.add(url,data);
  }

  update(url: string, data:StateMst): Observable<StateMst> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
